export default "__VITE_ASSET__D5Zn3at1__"